var React = require('react');
var Input = require('../input');
var css = require('./module.scss');

/**
 * 使用方法：
 * <CheckBox
 *     className='checkboxMg'
 *     title="香蕉"
 *     onChange={ this.checkboxChange }
 * />
 *
 * onChange回调中返回参数：checked状态，e事件对象
 */
var Checkbox = React.createClass({

    getInitialState: function() {
        return {
            checked: this.props.checked
        };
    },

    /**
     * 回调外层onChange函数时，参数：
     * checked：当前元素的checked布尔值
     * e：事件对象
     * index：当前元素在list中的index值，若为单个checkbox该值为0
     */
    onChange: function(e) {
        if (this.props.disabled) {
            return;
        }
        var checked = !!this.refs.checkbox.checked;
        var index = this.props.listIndex || 0;
        this.props.onChange && this.props.onChange(checked, index, e);
    },

    render: function() {
        var type = this.props.type || "checkbox";
        var cls = ['fp-input-type', 'fp-' + type];
        var iCls = ['fp-default'];
        if (this.props.className) {
            cls.push(this.props.className);
        }

        if (this.props.checked) {
            iCls.push('fp-checked');
        }

        if (this.props.disabled) {
            cls.push('fp-checkbox-disabled');
        }

        return (
            <label className={cls.join(' ')}>
                <input
                    ref="checkbox"
                    type={type}
                    name={this.props.name}
                    disabled={this.props.disabled}
                    readonly={this.props.readonly}
                    onFocus={this.props.onFocus}
                    onBlur={this.props.onBlur}
                    onChange={this.onChange}
                    value={this.props.value}
                    checked={!!this.props.checked}
                />
                <span className={iCls.join(' ')}></span>
                {
                    this.props.title ? <span className="label-text">{this.props.title}</span>
                        : null
                }
            </label>
        );
    }

});

module.exports = Checkbox;



// WEBPACK FOOTER //
// ./component/checkbox/index.js